import { LicenseManager } from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(
  'CompanyName=IT,LicensedApplication=IT,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-033210,SupportServicesEnd=19_November_2023_[v2]_MTcwMDM1MjAwMDAwMA==c3c3dee28ecd90d144ef9c8d67790fe4',
);
